import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Instagram, ArrowRight, TrendingUp } from 'lucide-react';
import { smmDescription, smmHighlight } from '../mock';
import { ContactPromptCard } from './SharedUI';

export default function SMMSection() {
  const navigate = useNavigate();

  return (
    <section id="smm" className="section">
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-end',
          marginBottom: 56,
          gap: 24,
          flexWrap: 'wrap',
        }}
        className="reveal"
      >
        <div>
          <div className="section-label" style={{ marginBottom: 16 }}>
            06 &mdash; SMM
          </div>
          <h2 className="section-title" style={{ margin: 0, maxWidth: 760 }}>
            Social Media<br />
            <span style={{ color: 'rgba(245,245,245,0.45)' }}>Management.</span>
          </h2>
        </div>
        <div style={{ maxWidth: 460 }}>
          {smmDescription.map((line, i) => (
            <p
              key={i}
              style={{
                color: i === 0 ? '#f5f5f5' : 'rgba(245,245,245,0.6)',
                fontSize: 15,
                lineHeight: 1.7,
                margin: 0,
              }}
            >
              {line}
            </p>
          ))}
        </div>
      </div>

      <div className="twocol"
        style={{
          display: 'grid',
          gridTemplateColumns: 'minmax(0, 1.2fr) minmax(0, 1fr)',
          gap: 20,
        }}
      >
        {/* Instagram highlight card */}
        <div className="glass-card reveal" style={{ padding: 32, display: 'flex', flexDirection: 'column', gap: 20 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
            <div className="smm-logo">
              <Instagram size={24} strokeWidth={1.6} />
            </div>
            <div>
              <div
                className="mono"
                style={{
                  fontSize: 10,
                  letterSpacing: '0.3em',
                  color: 'rgba(245,245,245,0.45)',
                  textTransform: 'uppercase',
                }}
              >
                {smmHighlight.platform}
              </div>
              <div
                style={{
                  fontFamily: 'Space Grotesk, sans-serif',
                  fontSize: 26,
                  fontWeight: 500,
                  marginTop: 2,
                  letterSpacing: '-0.01em',
                }}
              >
                Instagram growth
              </div>
            </div>
          </div>

          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(3, 1fr)',
              gap: 14,
            }}
          >
            {smmHighlight.items.map((it) => (
              <div
                key={it}
                style={{
                  padding: '20px 16px',
                  border: '1px solid rgba(245,245,245,0.08)',
                  borderRadius: 12,
                  textAlign: 'center',
                  background: 'rgba(10,10,10,0.4)',
                }}
              >
                <TrendingUp size={16} strokeWidth={1.5} color="rgba(245,245,245,0.55)" />
                <div
                  style={{
                    marginTop: 10,
                    fontFamily: 'Space Grotesk, sans-serif',
                    fontSize: 18,
                    fontWeight: 500,
                  }}
                >
                  {it}
                </div>
                <div
                  className="mono"
                  style={{
                    marginTop: 4,
                    fontSize: 9,
                    letterSpacing: '0.3em',
                    color: 'rgba(245,245,245,0.4)',
                    textTransform: 'uppercase',
                  }}
                >
                  Real, retained
                </div>
              </div>
            ))}
          </div>

          <p style={{ color: 'rgba(245,245,245,0.6)', fontSize: 13, lineHeight: 1.6, margin: 0 }}>
            Genuine engagement, drip-fed for safety. Pricing scales with package &mdash; tap below for the full menu including YouTube and Snapchat.
          </p>
        </div>

        {/* See more */}
        <div className="see-more-card reveal" onClick={() => navigate('/smm')}>
          <div
            className="mono"
            style={{
              fontSize: 10,
              letterSpacing: '0.35em',
              color: 'rgba(245,245,245,0.5)',
              textTransform: 'uppercase',
            }}
          >
            / Full SMM menu
          </div>
          <h3
            style={{
              fontFamily: 'Space Grotesk, sans-serif',
              fontWeight: 500,
              fontSize: 24,
              margin: 0,
              letterSpacing: '-0.01em',
              color: '#f5f5f5',
            }}
          >
            See all platforms
          </h3>
          <p style={{ color: 'rgba(245,245,245,0.55)', fontSize: 13, lineHeight: 1.6, margin: 0, maxWidth: 240 }}>
            Instagram, YouTube, Snapchat &mdash; pricing & packages.
          </p>
          <span
            style={{
              marginTop: 6,
              display: 'inline-flex',
              alignItems: 'center',
              gap: 6,
              padding: '10px 18px',
              borderRadius: 999,
              background: '#f5f5f5',
              color: '#000',
              fontFamily: 'JetBrains Mono, monospace',
              fontSize: 10,
              letterSpacing: '0.3em',
              textTransform: 'uppercase',
            }}
          >
            Open <ArrowRight size={12} />
          </span>
        </div>
      </div>

      <ContactPromptCard message="Want a custom SMM bundle? Tell me your goals — I will build a quote." />
    </section>
  );
}
